import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import ViewSiteTemplate from 'component/view/Settings/ViewSiteTemplate';

import { findCachedListItem, requireObjectOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/templates/$templateId')({
  staticData: { routeTitle: t('settings.site_templates.title') },
  beforeLoad: async ({ context, params }) => {
    const options = RocketAPI.siteTemplates.getFindSiteTemplateQueryOptions(params.templateId);

    await requireObjectOperation({
      context,
      options,
      redirectTo: '/n/settings/account-and-security',
      cachedItem: findCachedListItem(
        context.queryClient,
        ['/v1/sites/templates'],
        data =>
          (data as { result?: { site_templates?: { template_id?: string }[] } } | undefined)?.result
            ?.site_templates,
        template => template.template_id === params.templateId
      ),
    });
  },
  component: ViewSiteTemplate,
});
